import React, { useState } from 'react'
import Layout from '../../Components/Layout';
import SendEmail from './SendEmail';
import { Icon } from "@iconify/react";
// import AddNewEmployee from './AddNewEmployee';
import { useNavigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { BigerTexts, Lightly } from '../../Assets/CSS/Text';
import EmployeeForm from './EmployeeForm';

const EmployeeOnboarding = () => {
    const [step, setStep] = useState(1);
    const navigate = useNavigate();

    return (
        <Layout>
            <Toaster position="top-right" reverseOrder={false} />
            <div className="backgound-main-content">
                <div className='d-flex gap-2 align-item-center mt-2 '>
                    <Icon icon='akar-icons:arrow-left' className='align-item-center mt-1' onClick={() => {
                        navigate(-1);
                    }} />
                    <h5 style={BigerTexts}>Employee Onboarding</h5>

                </div>

                {/* SUB TITLE */}
                <h6 style={{ ...Lightly, marginLeft: "24px" }}>
                    {step === 1 ? "Add New Employee" : "Send Email"}
                </h6>
                <div class="d-flex align-items-center gap-2 my-3">

                    <div class="progress flex-grow-1" style={{ height: " 6px" }}>
                        <div class="progress-bar" role="progressbar"
                            style={{
                                width: step === 1 ? "40%" : "100%",
                                backgroundColor: "#00AFEF"
                            }}
                        >
                        </div>
                    </div>

                    <span class="fw-semibold">  Step {step}/2</span>
                </div>
                {/* CONDITIONAL RENDER */}

                {step === 1 && <EmployeeForm next={() => setStep(2)} />}
                {step === 2 && <SendEmail />}
            </div>
        </Layout>
    )
}

export default EmployeeOnboarding